import axios from "./axios";
export const getFieldList = entity => axios.get(`/fields/v1/${entity}`);
export const getTabs = entity => axios.get(`/fields/v1/${entity}/tab`);
export const getExtraFields = entity => axios.get(`/fields/v1/${entity}/extra`);
export const getExtraFieldEntities = views => axios.get(`/fields/v1/extra/entities?views=${views}`);
export const getStandardField = id => axios.get(`/fields/v1/standard/${id}`);
export const getExtraField = id => axios.get(`/fields/v1/extra/${id}`);
export const getExtraFieldTab = id => axios.get(`/fields/v1/tab/${id}`);
export const createExtraField = data => axios.post('/fields/v1/extra', data);
export const createExtraFieldTab = data => axios.post('/fields/v1/tab', data);
export const updateStandardField = (id, data) => axios.put(`/fields/v1/standard/${id}`, data);
export const updateExtraFieldTab = (id, data) => axios.put(`/fields/v1/tab/${id}`, data);
export const deleteExtraFieldTab = id => axios.delete(`/fields/v1/tab/${id}`, {});
export const updateExtraField = (id, data) => axios.put(`/fields/v1/extra/${id}`, data);
export const deleteExtraField = id => axios.delete(`/fields/v1/extra/${id}`);
export const getCrudSchema = tableName => axios.get(`/fields/v1/${tableName}/crudSchema`);
export const createField = values => axios.post('/fields/v1/tab', values);
export const updateExtraFieldsOrder = data => axios.put(`/fields/v1/order/extra`, data);
export const updateTabsOrder = data => axios.put(`/fields/v1/order/tab`, data);
export const moveExtraFieldToTab = (extraId, tabId) => axios.put(`/fields/v1/extra/${extraId}/tab/${tabId}`);